angular
  .module('balanceDownload')
  .component('balanceDownload', {
    template: require('./balance-download.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', '$cookies', 'AuthService', 'envService',
      function balanceDownloadController($rootScope, $scope, $resource, $route, $location, $window, $translate, $cookies, AuthService, envService) {
        $rootScope.mainmenu = 'balance';
        $rootScope.menu = 'download';
        this.targetEmployeeId = '-1';
        this.showAll = false;
        const APIURL = envService.read('apiUrl');
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }
        this.employeeChanged = () => {
          const targetEmployeeId = this.targetEmployeeId > 0 ? this.targetEmployeeId : 1;
          $resource(`${APIURL}/admin/employees/${targetEmployeeId}/balances/months`).get((data) => {
            this.months = data.months;
            this.targetMonth = data.months[0];
          }, (err) => {
            console.error(err);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        };
        this.download = () => {
          const user = $cookies.get('user');
          console.log(user);
          $window.open(`${APIURL}/admin/employees/1/balances/download?MONTH=${this.targetMonth}&SHOW_ALL=${this.showAll}&COUNTRY_CODE=${JSON.parse(user).COUNTRY_CODE}`, '_blank');
        };
        this.employeeChanged();
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/balance-download/balance-download.component.js